import create from 'zustand';
import { persist } from 'zustand/middleware';

type CompareState = {
    products: any[];
    isTrayVisible: boolean;
    addProduct: (product: any) => void;
    removeProduct: (product: any) => void;
    clear: () => void;
    dismissTray: () => void;
    showTray: () => void;
    isCompareModalOpen: boolean;
    openCompareModal: () => void;
    closeCompareModal: () => void;
    closeCompareForNavigation: () => void;
};

export const getProductId = (product: any): string =>
    product?.sanitizedItemNumber ||
    product?.originalItemNumber ||
    product?.primaryProductNumber ||
    product?.alternativeItemNumber ||
    product?.id ||
    '';
export const useProductCompare = create<CompareState>(
    persist<CompareState>(
        (set) => ({
            products: [],
            isTrayVisible: false,

            addProduct: (product) =>
                set((state) => {
                    const productId = getProductId(product);

                    if (!productId) {
                        return state;
                    }

                    const alreadyExists = state.products.some(
                        (existingProduct) =>
                            getProductId(existingProduct) === productId
                    );

                    if (alreadyExists) {
                        return {
                            ...state,
                            products: state.products.map(
                                (existingProduct) =>
                                    getProductId(existingProduct) === productId
                                        ? product
                                        : existingProduct
                            ),
                        };
                    }

                    if (state.products.length >= 4) {
                        return state;
                    }

                    return {
                        products: [
                            ...state.products,
                            product,
                        ],

                        // Adding a product always brings the tray back.
                        isTrayVisible: true,
                    };
                }),

            removeProduct: (product) =>
                set((state) => {
                    const productId =
                        typeof product === 'string'
                            ? product
                            : getProductId(product);

                    if (!productId) {
                        return state;
                    }

                    const products = state.products.filter(
                        (existingProduct) =>
                            getProductId(existingProduct) !== productId
                    );

                    return {
                        products,
                        isTrayVisible: products.length > 0,
                    };
                }),

            dismissTray: () =>
                set({
                    isTrayVisible: false,
                }),

            clear: () =>
                set({
                    products: [],
                    isTrayVisible: false,
                }),
            showTray: () =>
                set((state) => ({
                    isTrayVisible:
                        state.products.length > 0,
                })),
            isCompareModalOpen: false,

            openCompareModal: () =>
                set({
                    isCompareModalOpen: true,
                    isTrayVisible: false,
                }),

            closeCompareModal: () =>
                set((state) => ({
                    isCompareModalOpen: false,
                    isTrayVisible: state.products.length > 0,
                })),
            closeCompareForNavigation: () =>
                set((state) => ({
                    isCompareModalOpen: false,
                    isTrayVisible: state.products.length > 0,
                })),
        }),
        {
            name: 'product-compare',
            getStorage: () => sessionStorage,
        }
    )
);